module.exports = __webpack_public_path__ + "img/blacksheep.84606d77.png";